module.exports = __webpack_public_path__ + "img/44.27784b6e.png";